import { Box, Typography } from '@mui/material';
import { formatNumberWithComma } from '@/helpers/format/formatNumber.js';
import { styled } from '@mui/material/styles';
import { useTranslate } from 'react-admin';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledProductAnalyticsInfo = styled(Box)(() => ({
    '& + &': {
        marginTop: '20px',
    },
    '& .progress-bar-header': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '24px',
    },
    '& .progress-bar-container': {
        width: '100%',
        '& .MuiLinearProgress-root': {
            borderRadius: 4,
            height: 10,
            width: '100%',
        },
    },
    '& .progress-bar-labels': {
        display: 'flex',
        flexDirection: 'column',
    },
    '& .progress-bar-label': {
        fontSize: '14px',
    },
    '& .progress-bar-label-small': {
        fontSize: '11px',
        marginTop: '-2px',
    },
    '& .progress-bar-percentage': {
        fontSize: '14px',
        fontWeight: '600',
    },
}));

const StyledProductProgressBarContainer = styled(Box)(({ theme }) => ({
    marginTop: '8px',
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        marginTop: '11px',
    },
    '& .progress-container': {
        position: 'relative',
        borderRadius: '2px',
        height: '6px',
        width: '100%',
        overflow: 'hidden',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: 0,
            width: '100%',
            height: '2px',
            backgroundColor: Palette.gray.gray100,
            transform: 'translateY(-50%)',
        },
    },
    '& .progress-bar': {
        position: 'relative',
        zIndex: 1,
        height: '100%',
        borderRadius: '2px',
        transition: 'width 0.3s ease-in-out',
    },
}));

export const ProductProgressBar = ({ percentage }) => {
    return (
        <StyledProductProgressBarContainer>
            <Box className='progress-container'>
                <Box
                    className='progress-bar'
                    sx={{
                        width: `${percentage}%`,
                        backgroundColor: Palette.blue.blue500,
                    }}
                />
            </Box>
        </StyledProductProgressBarContainer>
    );
};

export const ProductAnalyticsInfo = ({ code, value, total, validateCode }) => {
    const translate = useTranslate();
    if (!value) return null;

    const percentage = parseFloat(((value / total) * 100).toFixed(1));
    const percentageString = formatNumberWithComma(percentage);

    return (
        <StyledProductAnalyticsInfo>
            <Box className='progress-bar-header'>
                <Box className='progress-bar-labels'>
                    <Typography className='progress-bar-label' variant='caption'>
                        {validateCode ? translate(`resources.transaction.productsValidation.${code}`) : code}
                    </Typography>
                    {validateCode && (
                        <Typography className='progress-bar-label-small' variant='caption'>
                            {code}
                        </Typography>
                    )}
                </Box>
                {isFinite(percentage) ? <Typography className='progress-bar-percentage'>{percentageString}%</Typography> : null}
            </Box>
            <ProductProgressBar percentage={percentage} />
        </StyledProductAnalyticsInfo>
    );
};
